import axios from "axios";
import { API_URL } from "const/constants";
import { announceTermsRequired, isTermsRequiredError } from "../terms/termsEvents";

/**
 * Axios instance for the partner portal. Separate from the admin client so a partner request can
 * never accidentally inherit admin headers or interceptors, and so 403 PARTNER_NOT_ACTIVE can be
 * handled in one place.
 */
const partnerClient = axios.create({ baseURL: `${API_URL}/partner` });

partnerClient.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Newer terms published mid-session: every call is refused until they are accepted, so hand the
// refusal to the terms gate rather than letting each page show it as a load failure.
partnerClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (isTermsRequiredError(error)) announceTermsRequired();
    return Promise.reject(error);
  }
);

export default partnerClient;
